<div class="browse-include-exclude container-fluild" *ngIf="!hidden">
    <!--Header-->
    <div class="browse-header">
        <div class="col-11 d-inline-block browse-text">
            <strong>BROWSE/SEARCH</strong>
        </div>
        <div class="col-1 d-inline-block">
            <acl-ngx-button variant="static" label="Clear" (click)="resetAll()"></acl-ngx-button>
        </div>
    </div>

    <!--Selection table-->
    <div class="selection-table">
        <!--Search Input Container-->
        <div class="search-input-container">
            <acl-ngx-input leftElement="Search" [placeholder]="_settings.placeholder" [formControl]="searchString">
            </acl-ngx-input>
            <!--Loading-->
            <div *ngIf="loading" class="loading">
                <acl-ngx-icon color="#009ebd" size="20" name='Process'></acl-ngx-icon>
            </div>
        </div>
        <!--table-->
        <div *ngIf="items.length > 0" class="content-table scroll-bar" (infiniteScroll)="handleOnScroll($event)">
            <ul class="list-item">
                <li class="row no-gutters" *ngFor="let item of items">
                    <div class="col-10">
                        <div class="item-name">
                            <span>
                                {{_settings.column.dataKey ? item[_settings.column.dataKey] : _settings.column.accessor(item)}}
                            </span>
                        </div>
                        <div *ngIf="_settings.column.subtextAccessor">
                            {{_settings.column.subtextAccessor(item)}}</div>
                    </div>
                    <div class="col-2 include-exclude-buttons"
                        [ngClass]="!_settings.column.subtextAccessor ? 'include-exclude-icons-without-subVal' : 'include-exclude-icons'">
                        <!-- TODO svg is too heavy to render list when list is above 1000 so keeping fa icons -->
                        <!-- <span class="include-icon">
                            <acl-ngx-icon [ngClass]="{'checked': item.isInclude}" name='Check'
                                (click)="includeItem(item)">
                            </acl-ngx-icon>
                        </span>
                        <span *ngIf="_settings.exclude" class="exclude-icon">
                            <acl-ngx-icon [ngClass]="{'checked': item.isExclude}" name='StatusBan'
                                (click)="excludeItem(item)">
                            </acl-ngx-icon>
                        </span> -->

                        <span class="include-icon">
                            <i class="fa fa-check" [ngClass]="{'checked': item.isInclude}" (click)="includeItem(item)">
                            </i>
                        </span>
                        <span *ngIf="_settings.exclude" class="exclude-icon">
                            <i class="fa fa-ban" [ngClass]="{'checked': item.isExclude}" (click)="excludeItem(item)">
                            </i>
                        </span>
                    </div>
                </li>
            </ul>
        </div>
        <!--No Data to show-->
        <div class="null-state-text content-table" *ngIf="items && !items.length && !loading">
            <span>No Data Available</span>
        </div>
    </div>

    <!--Include & Exclude Table-->
    <div class="include-exclude-table row">
        <!--Include table-->
        <div class="include-table" [ngClass]="_settings.exclude ? 'col-6' : 'col-12'">
            <div class="row no-gutters">
                <div class="icon-name-combo" [ngClass]="_settings.showOperator ? 'col-6' : 'col-10'">
                    <acl-ngx-icon color="#009ebd" contentClass="icon-spacing" name='Check'></acl-ngx-icon>
                    <strong>INCLUDES</strong>
                </div>
                <div class="operators col-4 border-left" *ngIf="_settings.showOperator">
                    <acl-ngx-radio contentClass="or" value="{{operatorEnum.or}}"
                        [(ngModel)]="_dataConfig.includeOperator">OR
                    </acl-ngx-radio>
                    <acl-ngx-radio contentClass="and" value="{{operatorEnum.and}}"
                        [(ngModel)]="_dataConfig.includeOperator">AND
                    </acl-ngx-radio>
                </div>
                <div class="col-2 border-left">
                    <acl-ngx-button variant="static" label="Clear" (click)="resetIncludes()"></acl-ngx-button>
                </div>
            </div>

            <!--Include Selected Box-->
            <div class="show-include-items scroll-bar">
                <ul class="list-item">
                    <li class="row no-gutters" *ngFor="let item of selectedIncludeItems">
                        <div class="col-11">
                            <div class="item-name">
                                <span>
                                    {{_settings.column.dataKey ? item[_settings.column.dataKey] : _settings.column.accessor(item)}}
                                </span>
                            </div>
                            <div *ngIf="_settings.column.subtextAccessor">
                                {{_settings.column.subtextAccessor(item)}}
                            </div>
                        </div>
                        <div class="col-1"
                            [ngClass]="!_settings.column.subtextAccessor ? 'remove-selected-item-icon' : 'remove-selected-item-icon-with-subVal'">
                            <acl-ngx-icon [name]="'Remove'" (click)="removeSelectedIncludes(item)"></acl-ngx-icon>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!--Exclude table-->
        <div *ngIf="_settings.exclude" class="exclude-table col-6">
            <div class="row no-gutters">
                <div class="icon-name-combo" [ngClass]="_settings.showOperator ? 'col-6' : 'col-10'">
                    <acl-ngx-icon color="red" contentClass="icon-spacing" name='StatusBan'></acl-ngx-icon>
                    <strong>EXCLUDES</strong>
                </div>
                <div class="operators col-4 border-left" *ngIf="_settings.showOperator">
                    <acl-ngx-radio contentClass="or" value="{{operatorEnum.or}}"
                        [(ngModel)]="_dataConfig.excludeOperator">OR
                    </acl-ngx-radio>
                    <acl-ngx-radio contentClass="and" value="{{operatorEnum.and}}"
                        [(ngModel)]="_dataConfig.excludeOperator">AND
                    </acl-ngx-radio>
                </div>
                <div class="col-2 border-left">
                    <acl-ngx-button variant="static" label="Clear" (click)="resetExcludes()"></acl-ngx-button>
                </div>
            </div>

            <!--Exclude Selected Box-->
            <div class="show-exclude-items scroll-bar">
                <ul class="list-item">
                    <li class="row no-gutters" *ngFor="let item of selectedExcludeItems">
                        <div class="col-11">
                            <div class="item-name">
                                <span>
                                    {{_settings.column.dataKey ? item[_settings.column.dataKey] : _settings.column.accessor(item)}}
                                </span>
                            </div>
                            <div *ngIf="_settings.column.subtextAccessor">
                                {{_settings.column.subtextAccessor(item)}}
                            </div>
                        </div>
                        <div class="col-1"
                            [ngClass]="!_settings.column.subtextAccessor ? 'remove-selected-item-icon' : 'remove-selected-item-icon-with-subVal'">
                            <acl-ngx-icon name="Remove" (click)="removeSelectedExcludes(item)"></acl-ngx-icon>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</div>